/**
 * Descarga segura de un Blob como archivo, sin dejar nodos DOM huérfanos ni URLs sin revocar.
 * Evita el error `removeChild` cuando react-router o extensiones (Google Translate)
 * mutan el DOM y colisionan con `<a>` creados fuera del ciclo de vida de React.
 */
export function downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.rel = "noopener";
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    // Limpieza en microtask para que Safari acepte el download antes de retirar el nodo
    setTimeout(() => {
        try { document.body.removeChild(a); } catch { /* nodo ya retirado */ }
        URL.revokeObjectURL(url);
    }, 0);
}
